'use client'

import { OverlayProvider } from 'overlay-kit'
import { PropsWithChildren } from 'react'

export const OverlayRootProvider = ({ children }: PropsWithChildren) => {
  return <OverlayProvider>{children}</OverlayProvider>
}
